/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalKeysList } from "../funcs/externalKeysList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListExternalKeysResult } from "../models/components/listexternalkeysresult.js";
import {
  ListExternalKeysQueryParamProvider,
  ListExternalKeysRequest,
  ListExternalKeysSecurity,
} from "../models/operations/listexternalkeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ListExternalKeysQueryData = ListExternalKeysResult;

export function prefetchListExternalKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListExternalKeysRequest | undefined,
  security?: ListExternalKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListExternalKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListExternalKeysQuery(
  client$: GramCore,
  request?: ListExternalKeysRequest | undefined,
  security?: ListExternalKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListExternalKeysQueryData>;
} {
  return {
    queryKey: queryKeyListExternalKeys({
      provider: request?.provider,
      gramSession: request?.gramSession,
    }),
    queryFn: async function listExternalKeysQueryFn(
      ctx,
    ): Promise<ListExternalKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalKeysList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListExternalKeys(
  parameters: {
    provider?: ListExternalKeysQueryParamProvider | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "externalKeys", "list", parameters];
}
